import * as React from 'react';
import { History } from 'history';
import Model from './eventquiz-model';
import BaseList from '../base/base-list.component';

interface IProps {  
  history: History;
  root?: string;
  caption?: string;
  eventId: number;
  actions?: any;
  disableBackButton?: boolean;
  disableCard? : boolean;
}

interface IState {
}

export default class EventquizList extends React.Component<IProps, IState> {
    
  constructor(props: IProps) {
    super(props);
  }

  private onLoadAll = (data: any) => {
  }
  
  public render(): React.ReactNode {
    return (
      <BaseList history={this.props.history} parentId={this.props.eventId} caption={this.props.caption} endPointFilter={Model.endPointFilterList(this.props.eventId)} url={(this.props.root || '') + Model.url} model={Model} actions={['view']} onLoadAll={this.onLoadAll} disableBackButton={this.props.disableBackButton} disableCard={this.props.disableCard}/>
    );
  }
}
